export default "/assets/images/cozy-air-lg.db67023606954a01.jpg";